export enum EFeatureCategories {
	ADVANCED_CAPABILITIES = 'advancedCapabilities',
	ANALYTICS_AND_REPORTING = 'AnalyticsAndReporting',
	COMMUNICATION_AND_CALL_HANDLING = 'communicationAndCallHandling',
	KNOWLEDGE_AND_CRM = 'knowledgeAndCRM',
	PHONE_NUMBERS_AND_FORWARDING = 'phoneNumbersAndForwarding',
	SUPPORT_AND_SLA = 'supportAndSLA',
	WEBHOOKS = 'webhooks',
	WORKFLOWS = 'workflows',
}
